





































































































































































































































































































































































































































































































































































import { CategoryGetters } from '@/store/category/getters'
import { BrandSkuGetters } from '@/store/brand-sku/getters'
import { ChainStoreGetters } from '@/store/chain-store/getters'
import { ChannelGetters } from '@/store/channel/getters'
import {
  isQuestionnaireOnly,
  ReceiptSupplier,
  receiptSuppliers,
} from '@/types/receipt'
import {
  computed,
  defineComponent,
  onBeforeMount,
  ref,
  toRefs,
  watch,
} from '@vue/composition-api'
import {
  ChannelEntity,
  CreateQuestionnaireDto,
  QuestionnaireEntity,
} from '../../../../api/@types'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { prefectures } from '@/utils/prefectures'
import moment from 'moment'
import { CategoryActions } from '@/store/category/actions'
import { BrandSkuActions } from '@/store/brand-sku/actions'
import { ChannelActions } from '@/store/channel/actions'
import { ChainStoreActions } from '@/store/chain-store/actions'
import { useFormRef } from '@/composable/common/useFormRef'
import { getTargetCount, uploadImage } from '@/api/questionnaire'
import TagCreator from '@/components/organisms/questionnaire/TagCreator.vue'

type GenderList = ('male' | 'female' | 'other')[]
type MarriageList = ('married' | 'unmarried' | 'other')[]

type FieldType = {
  name: string
  nameAdmin: string
  isWelcome: boolean
  isRequiredCheck: boolean
  rewardPoint: number | null
  totalLimitDisplay: number | null
  totalLimit: number | null
  resetLimit: number | null
  parentCategories: number[]
  childCategories: number[]
  targetCodes: string[]
  dailyUpperLimitByJan: number | null
  channels: ChannelEntity[]
  chainStores: number[] | null
  dailyUpperLimitByChain: number | null
  dailyUpperLimit: number | null
  answerUpperLimit: number | null
  releaseDate: string | null
  releaseTime: string | null
  finishDate: string | null
  finishTime: string | null
  publicTime: string | null
  description: string
  targetSupplier: ReceiptSupplier | null
  targetGender: GenderList
  targetUpperLimitAge: number | null
  targetLowerLimitAge: number | null
  targetMarriage: MarriageList
  targetPrefecture: string[]
  memberCodeInputs: { name: string }[]
  image: string | null
  createdById: number | null
  finishDuration: number | null
  fixedQuestionnaireUrl: string | null
  imageUrl: string | null
}

type Props = {
  questionnaire: QuestionnaireEntity
  isAutomatic: boolean
}

export default defineComponent({
  name: 'QuestionnaireForm',
  components: { TagCreator },
  props: {
    questionnaire: {
      type: Object,
      default: () => ({}),
    },
    isAutomatic: {
      type: Boolean,
      default: true,
    },
  },
  setup(props: Props, context) {
    const { questionnaire: q } = toRefs(props)

    const genderEnumToList = (
      type: QuestionnaireEntity['targetGender'],
    ): FieldType['targetGender'] => {
      switch (type) {
        case 'male':
        case 'female':
        case 'other':
          return [type]
        case 'male_female':
          return ['female', 'male']
        case 'male_other':
          return ['male', 'other']
        case 'female_other':
          return ['female', 'other']
        case 'all':
          return ['male', 'female', 'other']
        default:
          return []
      }
    }

    const genderListToEnum = (
      genders: FieldType['targetGender'],
    ): QuestionnaireEntity['targetGender'] => {
      const genderSet = new Set(genders)

      if (genders.length === 1) {
        return genders[0]
      } else if (genderSet.size === 2) {
        if (genderSet.has('male') && genderSet.has('female')) {
          return 'male_female'
        } else if (genderSet.has('male') && genderSet.has('other')) {
          return 'male_other'
        } else if (genderSet.has('female') && genderSet.has('other')) {
          return 'female_other'
        }
      }
      return 'all'
    }

    const marriageEnumToList = (
      type: QuestionnaireEntity['targetMarriage'],
    ): FieldType['targetMarriage'] => {
      switch (type) {
        case 'married':
        case 'unmarried':
        case 'other':
          return [type]
        case 'married_unmarried':
          return ['married', 'unmarried']
        case 'married_other':
          return ['married', 'other']
        case 'unmarried_other':
          return ['unmarried', 'other']
        default:
          return []
      }
    }

    const marriageListToEnum = (
      marriages: FieldType['targetMarriage'],
    ): QuestionnaireEntity['targetMarriage'] => {
      const marriageSet = new Set(marriages)

      if (marriages.length === 1) {
        return marriages[0]
      } else if (marriageSet.size === 2) {
        if (marriageSet.has('married') && marriageSet.has('unmarried')) {
          return 'married_unmarried'
        } else if (marriageSet.has('married') && marriageSet.has('other')) {
          return 'married_other'
        } else if (marriageSet.has('unmarried') && marriageSet.has('other')) {
          return 'unmarried_other'
        }
      }
      return 'all'
    }

    const { getParentCategories, getChildCategories } = useActions<
      CategoryActions
    >('category', ['getParentCategories', 'getChildCategories'])
    const { getBrandSkus } = useActions<BrandSkuActions>('brandSku', [
      'getBrandSkus',
    ])
    const { getChannels } = useActions<ChannelActions>('channel', [
      'getChannels',
    ])
    const { getChainStores } = useActions<ChainStoreActions>('chainStore', [
      'getChainStores',
    ])

    const input = ref<FieldType>({
      name: q.value.name || '',
      nameAdmin: q.value.nameAdmin || '',
      isWelcome: q.value.isWelcome || false,
      isRequiredCheck: q.value.isRequiredCheck || false,
      rewardPoint: q.value.rewardPoint
        ? q.value.rewardPoint
        : q.value.rewardPoint === 0
        ? 0
        : null,
      totalLimitDisplay: q.value.totalLimitDisplay || null,
      totalLimit: q.value.totalLimit || null,
      resetLimit: q.value.resetLimit || null,
      parentCategories: [],
      childCategories: q.value.pobCategoryIds || [],
      targetCodes: q.value.targetCodes || [],
      dailyUpperLimitByJan: q.value.dailyUpperLimitByJan || null,
      channels: [],
      chainStores: q.value.chainStoreIds,
      dailyUpperLimitByChain: q.value.dailyUpperLimitByChain || null,
      dailyUpperLimit: q.value.dailyUpperLimit || null,
      answerUpperLimit: q.value.answerUpperLimit || null,
      releaseDate:
        (q.value.releaseAt && moment(q.value.releaseAt).format('YYYY-MM-DD')) ||
        null,
      releaseTime:
        (q.value.releaseAt && moment(q.value.releaseAt).format('HH:mm')) ||
        null,
      finishDate:
        (q.value.finishAt && moment(q.value.finishAt).format('YYYY-MM-DD')) ||
        null,
      finishTime:
        (q.value.finishAt && moment(q.value.finishAt).format('HH:mm')) || null,
      publicTime: q.value.publicTime,
      description: q.value.description || '',
      targetSupplier: (q.value.targetSupplier as ReceiptSupplier) || null,
      targetGender: genderEnumToList(q.value.targetGender),
      targetUpperLimitAge: q.value.targetUpperLimitAge || null,
      targetLowerLimitAge: q.value.targetLowerLimitAge || null,
      targetMarriage: marriageEnumToList(q.value.targetMarriage),
      targetPrefecture: q.value.targetPrefecture || [],
      memberCodeInputs: (q.value.memberCodes || []).map(mc => ({ name: mc })),
      image: '',
      createdById: q.value.createdById ?? null,
      finishDuration: q.value.finishDuration ?? null,
      fixedQuestionnaireUrl: q.value.fixedQuestionnaireUrl,
      imageUrl: q.value.imageUrl,
    })

    watch(
      () => input.value.parentCategories,
      val => {
        const ids = val.length > 0 ? val : undefined
        getChildCategories(ids)
      },
    )

    watch(
      () => input.value.childCategories,
      val => {
        const categories = val.length > 0 ? val : []
        getBrandSkus({ name: '', jicsfClassificationCds: categories })
      },
    )

    watch(
      () => input.value.channels,
      val => {
        const channelIds = val.length > 0 ? [...val.map(i => i.id)] : undefined
        getChainStores({ channelIds, limit: 1000 })
      },
    )

    const shouldShowFixedUrl = computed(() => {
      if (input.value.targetSupplier === null) {
        return false
      }
      const should = isQuestionnaireOnly(input.value.targetSupplier)
      if (should) {
        input.value.rewardPoint = 1
      }
      return should
    })

    const isDiabled = computed(() => {
      if (q.value.status === 'public') {
        return true
      } else {
        return false
      }
    })

    const imageInput = ref({
      imageFile: null as File | null,
    })

    const targetMonitorCountInput = ref({
      targetMonitorCount: null as number | null,
    })

    const { form, validate } = useFormRef()

    const { channels } = useGetters<ChannelGetters>('channel', ['channels'])
    const { chainStores } = useGetters<ChainStoreGetters>('chainStore', [
      'chainStores',
    ])
    const { parents, children } = useGetters<CategoryGetters>('category', [
      'parents',
      'children',
    ])
    const { brandSkus } = useGetters<BrandSkuGetters>('brandSku', ['brandSkus'])

    const minDate = moment().format('YYYY-MM-DD')
    const rules = [(v: any) => !!v || v === 0 || '必須項目です。']
    const minZeroRule = [
      (v: any) =>
        !v ||
        (typeof v === 'number' && Number(v) > 0) ||
        (typeof v === 'string' && Number(v) > 0) ||
        '1以上の値を入力してください。',
    ]
    const validPublicTime = [
      (v: any) =>
        !v ||
        /^\d{2}:\d{2}-\d{2}:\d{2}$/.test(v) ||
        'HH:MM-HH:MMの形式で入力してください。',
    ]

    const save = () => {
      if (shouldShowFixedUrl.value) {
        input.value.rewardPoint = 0
      }
      if (!validate()) {
        return
      }

      const releaseAt = moment(
        `${input.value.releaseDate} ${input.value.releaseTime ?? '00:00'}`,
      )
      const finishAt = moment(
        `${input.value.finishDate} ${input.value.finishTime ?? '00:00'}`,
      )
      if (releaseAt.isAfter(finishAt)) {
        return
      }

      if (input.value.publicTime) {
        if (
          /^\d{2}:\d{2}-\d{2}:\d{2}$/.test(input.value.publicTime) === false
        ) {
          return
        }
        const publicTimeStart = moment(
          input.value.publicTime.split('-')[0],
          'HH:mm',
        )
        const publicTimeEnd = moment(
          input.value.publicTime.split('-')[1],
          'HH:mm',
        )
        if (
          publicTimeStart.isValid() === false ||
          publicTimeEnd.isValid() === false
        ) {
          return
        }
      }

      const toNullOrNumber = (input: number | null) => {
        if (input === null || input.toString().length === 0) {
          return null
        }
        const parsed = Number(input)
        return isNaN(parsed) ? null : parsed
      }

      const body: CreateQuestionnaireDto = {
        ...input.value,
        dailyUpperLimit: toNullOrNumber(input.value.dailyUpperLimit),
        dailyUpperLimitByChain: toNullOrNumber(
          input.value.dailyUpperLimitByChain,
        ),
        dailyUpperLimitByJan: toNullOrNumber(input.value.dailyUpperLimitByJan),
        targetGender: genderListToEnum(input.value.targetGender),
        targetUpperLimitAge: toNullOrNumber(input.value.targetUpperLimitAge),
        targetLowerLimitAge: toNullOrNumber(input.value.targetLowerLimitAge),
        targetMarriage: marriageListToEnum(input.value.targetMarriage),
        finishDuration: toNullOrNumber(input.value.finishDuration),
        rewardPoint: toNullOrNumber(input.value.rewardPoint) || 0,
        pobCategoryIds: input.value.childCategories,
        targetCodes: input.value.targetCodes,
        chainStoreIds: input.value.chainStores || [],
        releaseAt: releaseAt.format(),
        finishAt: finishAt.format(),
        createdById: Number(input.value.createdById),
        isAutomatic: props.isAutomatic,
        isWelcome: input.value.isWelcome,
        memberCodes: input.value.memberCodeInputs.map(mci => mci.name),
      }
      context.emit('submit', body)
    }

    const upload = async () => {
      if (!imageInput.value.imageFile) {
        return
      }
      input.value.image = await uploadImage(imageInput.value.imageFile)
    }

    const copyUrl = () => {
      if (window.navigator.clipboard === undefined) {
        return
      }
      window.navigator.clipboard.writeText(input.value.image || '')
    }

    const checkTargetMonitorCount = async () => {
      targetMonitorCountInput.value.targetMonitorCount = -1
      targetMonitorCountInput.value.targetMonitorCount = await getTargetCount(
        props.questionnaire.id,
      )
    }

    const addChoice = (inputText: string) => {
      const memberCodeInputs = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(choice => choice.trim())
        .map(name => ({ name, isLast: false }))
      input.value.memberCodeInputs.push(...memberCodeInputs)
    }

    const removeChoice = (index: number) => {
      input.value.memberCodeInputs = input.value.memberCodeInputs.filter(
        (_, i) => i !== index,
      )
    }

    const removeAll = () => {
      input.value.memberCodeInputs = []
    }

    const editChoice = (data: { index: number; name: string }) => {
      input.value.memberCodeInputs = input.value.memberCodeInputs.map(
        (memberCodeInput, i) => {
          if (i === data.index) {
            return { ...memberCodeInput, name: data.name }
          }
          return memberCodeInput
        },
      )
    }

    const cancel = () => {
      context.emit('cancel')
    }

    onBeforeMount(() => {
      Promise.all([
        getParentCategories(),
        getChildCategories(undefined),
        getChannels(),
        getChainStores({ limit: 1000 }),
        getBrandSkus({
          name: '',
          jicsfClassificationCds: q.value.pobCategoryIds || [],
        }),
      ])
    })

    return {
      input,
      imageInput,
      form,
      channels,
      chainStores,
      parents,
      children,
      brandSkus,
      prefectures,
      receiptSuppliers,
      minDate,
      rules,
      minZeroRule,
      validPublicTime,
      targetMonitorCountInput,
      shouldShowFixedUrl,
      save,
      upload,
      copyUrl,
      checkTargetMonitorCount,
      addChoice,
      removeChoice,
      removeAll,
      editChoice,
      cancel,
      isDiabled,
    }
  },
})
